import React from "react";
import { colors } from '../../../theme/colors';
import { Box, Typography, Button } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { ConfirmSubmitDialog } from "../../../pages/app/technical-assessment/style";

const ConfirmSubmissionDialogBox = ({
  open,
  onClose,
  onSubmit,
  isLoading = false,
}) => {
  return (
    <ConfirmSubmitDialog open={open} onClose={onClose}>
      <Box className="confirm-icon">
        <WarningAmberIcon sx={{ fontSize: "32px", color: "#ef6c00" }} />
      </Box>
      <Typography className="confirm-title">Submit Assessment?</Typography>
      <Typography className="confirm-message">
        Are you sure you want to submit? Once submitted, you will not be able to
        modify your answers. Please make sure you have reviewed all your
        solutions.
      </Typography>
      <Box className="confirm-actions">
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={isLoading}
          sx={{
            borderRadius: "10px",
            textTransform: "none",
            borderColor: "#d0d5dd",
            color: "#344054",
            px: 3,
          }}
        >
          Review Again
        </Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={isLoading}
          sx={{
            borderRadius: "10px",
            textTransform: "none",
            backgroundColor: colors.primary,
            px: 3,
            "&:hover": { backgroundColor: colors.primaryHover },
          }}
        >
          {isLoading ? "Submitting..." : "Submit Now"}
        </Button>
      </Box>
    </ConfirmSubmitDialog>
  );
};

export default ConfirmSubmissionDialogBox;
